export default __webpack_public_path__ + "static/media/aus-flag.3f1c37ef.jpeg";